import { getJobColors } from "../../../../core/Global"

interface IProps {
    /** The technician's job colour id (Technician.techJobColorId). */
    colorId?: string
    size?: number
    className?: string
}

/** A technician's job colour as a small dot beside their name; nothing when they have none. */
export default function TechColorDot(props: IProps) {
    const c = props.colorId ? getJobColors().find(x => x.id == props.colorId) : undefined
    if (!c?.color) return null

    const size = props.size ?? 9
    return (
        <span title={`Job color: ${c.name ?? c.color}`}
            className={`d-inline-block rounded-circle flex-shrink-0 ${props.className ?? "ms-2"}`}
            style={{ width: size, height: size, backgroundColor: c.color, boxShadow: "0 0 0 1px rgba(0, 0, 0, .12)" }} />
    )
}
